import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';

export default function LogoutCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { logout } = useAuth();

  useEffect(() => {
    const handleLogout = async () => {
      await logout();

      const redirectTo =
        searchParams.get('redirectTo') || '/login?logged_out=1';

      navigate(redirectTo, { replace: true });
    };

    handleLogout();
  }, [navigate, searchParams, logout]);

  return <div>Logging out, please wait...</div>;
}
